var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { AppSideMenuIconButton, AppSideMenuIcon, AppSideNavigationMenu, AppSideNavigationMenuMain, } from './styles';
import { useHistory, Link } from 'react-router-dom';
import findSelectedMenu from '../../utils/findSelectedMenu/findSelectedMenu';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import AppBuilderMenu from './navigation';
import { makeSelectPlatformVersion } from '@project/containers/Root/selectors';
import { selectSelectedApp } from '../../../store/selectedApp/selectors';
import { selectAppSettings } from '../../../store/appSettings/selectors';
import { isMajorMinorEqual } from '@project/utils/version';
import { CustomTooltip } from '../../../components/base';
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { PermissionsWrapper } from '@project/components/PermissionsWrapper';
import selectStructure from '../../../containers/StructureBuilderPage/selectors';
import AppBuilderMenuItem from '../../../components/AppBuilderMenuItem';
import { clearSelectedApp } from '../../../store/selectedApp/actions';
var Tooltip = function (_a) {
    var title = _a.title, children = _a.children;
    return (_jsx(CustomTooltip, __assign({ title: title, placement: "right", arrow: true, disableFocusListener: true, disableTouchListener: true, TransitionProps: { timeout: 300 }, enterDelay: 500, enterNextDelay: 500 }, { children: _jsx("div", { children: children }) })));
};
var AppBuilderSideBar = function (_a) {
    var _b, _c;
    var appId = _a.appId, orgId = _a.orgId;
    var dispatch = useDispatch();
    var history = useHistory();
    // ====views==================updates availability========================
    var currentApp = useSelector(selectSelectedApp);
    var views = useSelector(selectStructure).views;
    var platformVersion = useSelector(makeSelectPlatformVersion());
    var appSettings = useSelector(selectAppSettings);
    var appDataLoading = appSettings.appDataLoading;
    var isUpToDate = isMajorMinorEqual((_b = currentApp === null || currentApp === void 0 ? void 0 : currentApp.app) === null || _b === void 0 ? void 0 : _b.platform_version, platformVersion) ||
        appDataLoading;
    // ======================!updates availability ========================
    var AppBuilderMenuItems = AppBuilderMenu(appId, orgId, isUpToDate);
    // ======================find selected menu item ========================
    var pathNameArray = history.location.pathname.split('/');
    var selectedMenu = findSelectedMenu(AppBuilderMenuItems.filter(function (menu) { return menu.id !== 3; }), history.location.pathname);
    var selectedMenuId = pathNameArray[5] === 'structure' || ((_c = pathNameArray[5]) === null || _c === void 0 ? void 0 : _c.length) === 19
        ? 3
        : selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.id;
    // ======================!find selected menu item ========================
    return (_jsxs(AppSideNavigationMenuMain, { children: [_jsxs(AppSideNavigationMenu, { children: [_jsx(AppSideMenuIconButton, __assign({ home: true, onClick: function () {
                            clearSelectedApp();
                            dispatch(push("/organizations/".concat(orgId, "/apps")));
                        } }, { children: _jsx(AppSideMenuIcon, { icon: faHome }) })), AppBuilderMenuItems.map(function (item) { return (_jsx(PermissionsWrapper, __assign({ hideOnDisable: true, target: item.target || "app:".concat(appId), action: "read" }, { children: _jsx(Tooltip, __assign({ title: item.header }, { children: _jsx(AppSideMenuIconButton, __assign({ onClick: function () {
                                    if ((item === null || item === void 0 ? void 0 : item.id) === 2 && views.length) {
                                        var viewToPush = appId === localStorage.getItem('VB_SELECTED_APP')
                                            ? localStorage.getItem('VB_SELECTED_VIEW') ||
                                                views[0].id
                                            : views[0].id;
                                        dispatch(push("/organizations/".concat(orgId, "/apps/").concat(appId, "/views/").concat(viewToPush)));
                                    }
                                    else {
                                        dispatch(push(item.slug));
                                    }
                                }, selected: item.id === selectedMenuId }, { children: item.icon })) }), item.id) }), item.id)); })] }), _jsx(AppSideNavigationMenu, { children: _jsx(Link, __assign({ to: {
                        pathname: 'https://academy.appspotr.com/academy/latest/welcome/index.html',
                    }, target: "_blank" }, { children: _jsx(AppBuilderMenuItem, { title: "Help", iconName: faQuestionCircle, tooltipText: "Help" }) })) })] }));
};
export default AppBuilderSideBar;
